import { useMutation } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { INVITABLE_ENTITIES } from '@/enums/invitable-entities.enum.ts';
import type { InviteToOrganizationPayload } from '@/types/dtos/invitations/request/invite-to-organization.dto.ts';

export const useInviteToOrganizationMutation = () => {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (invitationPayload: InviteToOrganizationPayload) => {
      const token = await getToken();
      return inviteToOrganization(invitationPayload, token ?? '');
    },
  });
};

const inviteToOrganization = async (invitationPayload: InviteToOrganizationPayload, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/invitations/organization`;
  const { organizationId, elevatedRoles, basicRoles, ...invitationPayloadWithoutOrganizationId } = invitationPayload;
  await sendJSONRequest({
    url,
    method: METHOD.POST,
    body: {
      ...invitationPayloadWithoutOrganizationId,
      ...(elevatedRoles?.length ? { elevatedRoles } : {}),
      ...(basicRoles?.length ? { basicRoles } : {}),
      entityType: INVITABLE_ENTITIES.ORGANIZATION,
      entityId: organizationId,
    },
    token,
  });
};
